/**
 * KTUI - Free & Open-Source Tailwind UI Components by Keenthemes
 * Copyright 2025 by Keenthemes Inc
 */

export { KTAccordion } from './accordion';
export type { KTAccordionConfigInterface, KTAccordionInterface } from './types';
